import useResponsive from '@parsina/framework/clinical/src/hooks/useResponsive';
import AccountingWeb from './Accounting.web';
import AccountingMobile from './Accounting.mobile';

// DESIGN-CONCEPT-MOBILE v2 §1.1: the two surfaces are independent render trees
// over one shared logic layer (`useAccounting` + `Accounting.shared`), not a
// responsive tier of the desktop table.
const AccountingScreen = () => {
  const { isMobile } = useResponsive();
  return isMobile ? <AccountingMobile /> : <AccountingWeb />;
};

export default AccountingScreen;
